import React, { Component } from "react";
import { ConstantBasedPicker } from "@openimis/fe-core";

import { SCHEME_STATUS } from "../constants";

class SchemeStatusPicker extends Component {

    render() {
        const { readOnly = false, required = false, withNull = true, nullLabel = null } = this.props;
        
        return <ConstantBasedPicker
            module="scheme"
            label="Scheme Status"
            constants={SCHEME_STATUS}
            readOnly={readOnly}
            {...this.props}
        />
    }
}

export default SchemeStatusPicker;